import {Box, IconButton, Modal} from "@mui/material";
import React from "react";
import ClearIcon from "assets/icons/Clear";

interface QuestionModalProps {
  open: boolean;
  onClose: () => void;
}

const QuestionModal = ({open, onClose}: QuestionModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'white',
        width: {xxs: '98%', md: '80%'},
        height: '80%',
        px: {xxs: 2, md: 3.5},
        pb: 4,
        pt: 2
      }}>
        <Box display={'flex'} justifyContent={'flex-end'} pb={1}>
          <IconButton
            onClick={onClose}
            sx={{backgroundColor: 'grey.400', borderRadius: 2, width: 32, height: 32,}}>
            <ClearIcon sx={{width: 10, height: 10}}/>
          </IconButton>
        </Box>
        <iframe
          src="https://id.pervye.ru/widget/support_feedback"
          width="100%"
          height="95%"
          frameBorder={'none'}
          title="iframe-title-feedback"
        >
        </iframe>
      </Box>
    </Modal>
  )
}

export default QuestionModal;
